var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"question-third-step"},[_c('Draggable',{model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},_vm._l((_vm.files),function(preFile){return _c('Box',_vm._g({key:preFile.pid,attrs:{"validate":false,"boxConfig":preFile}},_vm.$listeners))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }